import { RequestOthURL } from "../../../Library/AxiosLibWithHeader2";
import { Request2Estes } from "../../../Templates/components/APIs";

const GET_ADDRESS_BY_REFF = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_ADDRESS_BY_REFF",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_ADDRESS_BY_ID = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_ADDRESS_BY_ID",
  };
  const result = await Request2Estes(payload);

  return result;
};


const GET_LOOK_UP_COUNTRY = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_LOOK_UP_COUNTRY",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_LOOK_UP_CITY = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_LOOK_UP_CITY",
  };
  const result = await Request2Estes(payload);

  return result;
};

const CREATE_ADDRESS = async (param) => {
  const payload = {
    parameters: param,
    target_data: "CREATE_ADDRESS",
  };
  const result = await Request2Estes(payload);

  return result;
};

const UPDATE_ADDRESS = async (param) => {
  const payload = {
    parameters: param,
    target_data: "UPDATE_ADDRESS",
  };
  const result = await Request2Estes(payload);

  return result;
};


const GET_FAMILY_BY_REFF = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_FAMILY_BY_REFF",
  };
  const result = await Request2Estes(payload);

  return result;
};

const CREATE_FAMILY = async (param) => {
  const payload = {
    parameters: param,
    target_data: "CREATE_FAMILY",
  };
  const result = await Request2Estes(payload);

  return result;
};

const UPDATE_FAMILY = async (param) => {
  const payload = {
    parameters: param,
    target_data: "UPDATE_FAMILY",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_PROFESSION_LOOKUP = async () => {
  const payload = {
    target_data: "GET_PROFESSION_LOOKUP",
  };
  const result = await Request2Estes(payload);

  return result;
};


const GET_PROVINCE_LOOKUP = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_PROVINCE_LOOKUP",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_COUNTRY_BY_ID = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_COUNTRY_BY_ID",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_PROVINCE_BY_ID = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_PROVINCE_BY_ID",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_RELIGION_LOOKUP = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_RELIGION_LOOKUP",
  };
  const result = await Request2Estes(payload);

  return result;
};

const wilayah_id_uri = process.env.REACT_APP_WILAYAH_API || "https://wilayah.id/api/";
const GET_PROVINCE_API_WILAYAHID = async () => {
  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${wilayah_id_uri}provinces.json`,
    headers: {}
  };

  const results = await RequestOthURL(config);
  // console.log("province:",results);
  if (results.data && Object.values(results.data).length > 0) {
    const r_data = results.data || [];
    return { loading: false, message: "", data: r_data };
  } else {
    return { loading: false, data: [], message: results?.error || "Failed request" }
  }
}

const GET_KECAMATAN_LOOKUP = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_KECAMATAN_LOOKUP",
  };
  const result = await Request2Estes(payload);

  return result;
};

const UPDATE_STUDENT_DATA = async (param) => {
  const payload = {
    parameters: param,
    target_data: "UPDATE_STUDENT_DATA",
  };
  const result = await Request2Estes(payload);

  return result;
};

const UPDATE_CANDIDATE = async (param) => {
  const payload = {
    parameters: param,
    target_data: "UPDATE_CANDIDATE",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_ENROLLMENT_PROCESS_BY_ID = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_ENROLLMENT_PROCESS_BY_ID",
  };
  const result = await Request2Estes(payload);

  return result;
};

export {
  GET_ADDRESS_BY_REFF, GET_ADDRESS_BY_ID, GET_LOOK_UP_COUNTRY, GET_LOOK_UP_CITY, CREATE_ADDRESS, UPDATE_ADDRESS,
  GET_FAMILY_BY_REFF, CREATE_FAMILY, UPDATE_FAMILY, GET_PROFESSION_LOOKUP,
  GET_PROVINCE_LOOKUP, GET_COUNTRY_BY_ID, GET_PROVINCE_BY_ID, GET_RELIGION_LOOKUP, GET_PROVINCE_API_WILAYAHID, GET_KECAMATAN_LOOKUP,
  UPDATE_STUDENT_DATA, UPDATE_CANDIDATE, GET_ENROLLMENT_PROCESS_BY_ID
};
